import { Tab, Tabs } from "react-bootstrap";
import { useEffect, useState } from "react";
import apiService from "Services/apiService";
import TableRender from "components/common/TableRender/TableRender"
import { SkeTable } from "components/common/Skeleton/SkeTable";
import Search from "components/common/Search/Search";
import polizaImg from "assets/img/polizasStock.svg";
import { formatDate } from "Utils/Fn/DateParser";
import Button from "components/common/Button/Button";


import { DynamicRow } from "Interface/generic.model";
import e from "./style.module.css";
import ModalPolicies from "./Modal/ModalPolicies";
import ModalReports from "components/common/Modals/ModalReport";
import AlertNotification, {IAlert} from "components/common/AlertNotification/AlertNotification";

export const PoliciesList = () => {
  
  const [loading, setLoading] = useState(true);
  const [loadingInactive, setLoadingInactive] = useState(true);
  const [alert, setAlert] =  useState<IAlert>({ show: false, title: '', details: '', variant: 'Success' });
  const [allPolicies, setAllPolicies] = useState<any[]>([]);
  const [allInactivePolicies, setAllInactivePolicies] = useState<any[]>([]);
  const [policies, setPolicies] = useState<any[]>([]);
  const [inactivePoliciesLoaded, setInactivePoliciesLoaded] = useState(false);
  const [show, setShow] = useState(false);
  const [showMReports, setShowMReports] = useState(false);
  const [selectedElement, setSelectedElement] = useState<any>(null);
  const [selectedRamoFilter, setSelectedRamoFilter] = useState<string | null>(null);
  const [inputFilter, setInputFilter] = useState<string | null>(null);
  const [disableBtn] = useState<boolean>(false);
  

  const POLICIES_TABLE_ROWS = [
    {label: 'Cód. Póliza', key: 'codPoliza'},
    {label: 'Aseguradora', key: 'aseguradora'},
    {label: 'Nro. Póliza', key: 'numPoliza'},
    {label: 'Ramo', key: 'ramo'},
    {label: 'Prima', key: '_prima', class: 'text-right', classBody: 'text-right'},
    {label: 'Fin de vigencia', key: '_due_date'},
  ];
  const SLOT = {label: 'Detalle', key: 'fleetsSlot', slotName: 'fleetsSlot'};

  useEffect(() => {
    apiService({
      name: 'getPoliciesCop',
      queryParams: {_codigoCliente: JSON.parse(localStorage.getItem('cliCod') || '{}') || ''},
      onSuccess: ({response}) => {
        const resp = response.map((data: any) => (
          {...data,
            id: data.codPoliza,
            _due_date: formatDate(data.fin_de_Vigencia),
            _prima: '$' + data.prima
          }
        ));
        setAllPolicies(resp);
        setPolicies(resp);
      },
      onError: (error) => {
        console.error('Error:', error);
        setAlert({
          show: true,
          title: 'Error al obtener datos',
          details: error,
          variant: 'Danger'
        })
      },
      onFinally() {
        setLoading(false);
      }
    });
  }, []);

  const resetAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };

  const handleTabSelect = (key: string | null) => {
    if (key === "inactivePolicies" && !inactivePoliciesLoaded) {
      apiService({
        name: 'getInactivePoliciesCop',
        queryParams: {_codigoCliente : JSON.parse(localStorage.getItem('cliCod') || '{}') || ''},
        onSuccess: ({ response }) => {
          const resp = response.map((data: any) => (
            {...data,
              id: data.codPoliza,
              _due_date: formatDate(data.fin_de_Vigencia),
              _prima: '$' + data.prima
            }
          ));
          setAllInactivePolicies(resp)
          setInactivePoliciesLoaded(true);
        },
        onError: (error) => {
          console.error('Error:', error);
          setAlert({
            show: true,
            title: 'Error al obtener datos',
            details: error,
            variant: 'Danger'
          })
        },
        onFinally() {
          setLoadingInactive(false);
        }
      });
    }
  };

  const fleetsSlotBtn = (row: DynamicRow) => {
    return (
      <button
        type="button"
        id={row.id}
        className={`btn btn-link primary-text ${e['btn_slot-modal']}`}
        onClick={() => openModal(row)}
      >
        Ver detalles
      </button>
    );
  };

  const openModal = (selectData: DynamicRow) => {
    setSelectedElement(selectData);
    setShow(true);
  };

  

  const filterBy = (fil: string, e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const searchValue = e.target.value
    if (!searchValue && !selectedRamoFilter && !inputFilter) {
      setAllPolicies(policies)
    }
    const isSelect = e.target.type === 'select-one';
    const saveValue = isSelect ? inputFilter : selectedRamoFilter
    const colSave = isSelect ? 'numPoliza' : 'ramo'
    setAllPolicies(
      policies.filter((item) => {
        if (!!saveValue) {
          return item[fil].toLowerCase().startsWith(searchValue.toLowerCase()) &&
          item[colSave].toLowerCase().startsWith(saveValue.toLowerCase());
        } else {
          return item[fil].toLowerCase().startsWith(searchValue.toLowerCase());
        }
      })
    );
  };

  return (
    <>
      <div className="container pb-3">
        <section className="row">
          <div className="col-md-4 col-lg-3">
            <img
              src={polizaImg}
              alt="Imagen vector de archivo con folder"
              className={e.img_polizas}
            />
          </div>
          <div className="col-md-8 col-lg-9 text-center text-md-start">
            <h3>Pólizas</h3>
            <p className="mb-1">Consulta de pólizas y descarga marbete.</p>
            <div className="d-flex justify-content-center justify-content-md-start">
              <span className="deco_line" />
            </div>
            <div className="d-flex justify-content-center justify-content-md-start justify-content-lg-end">
              <Button type="button" onClick={() => setShowMReports(true)} disabled={disableBtn} showLoading={true} value="Generar Reporte" className="px-3 py-2 mt-2 mt-lg-0"/>
            </div>
            <div className="row mt-3 mt-md-5 px-3 p-md-1">
              <div className="col-lg-5">
                <label className="bold">
                  Ver solo:
                </label>
                <select 
                  className="form-select text-capitalize"
                  aria-label="Ver solo - póliza"
                  onChange={(e) => {
                    setSelectedRamoFilter(e.target.value);
                    filterBy("ramo", e);
                  }}
                >
                  <option value="">Todos los ramos</option>
                  {policies.length >= 1 && Array.from(
                    new Set(policies.map((obj) => obj.ramo.toLowerCase()))
                  ).map((type, i) => (
                    <option
                      key={`${type}_${i}`}
                      value={type}
                    >
                      {type}
                    </option>
                  ))}
                </select >
              </div>
              <div className="col-lg-5">
                <Search
                  onChange={(e) => {
                    setInputFilter(e.target.value)
                    filterBy("numPoliza", e)
                  }}
                  label="Buscar por número de póliza"
                  placeholder="Número de póliza"
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className={`pt-4 pb-5 container-fluid ${e.table_ctn}`}>
        <div className="container">
        <Tabs
          defaultActiveKey="activePolicies"
          id="tab-PoliciesList"
          className="mb-3"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="activePolicies" title="Pólizas activas">
            {loading ? (
              <SkeTable
                col={10}
                row={8}
                className="pt-1"
              />
            ) : (
              <div className={e['table-container']}>
                <TableRender
                  id="PolicesListTable"
                  schema={[...POLICIES_TABLE_ROWS, SLOT]}
                  rows={allPolicies}
                  slots={{
                    'fleetsSlot': fleetsSlotBtn
                  }}
                />
              </div>
              
            )}
          </Tab>
          <Tab eventKey="inactivePolicies" title="Pólizas inactivas">
            {loadingInactive ? (
              <SkeTable
                col={10}
                row={8}
                className="pt-1"
              />
            ) : (
              <div className={e['table-container']}>
                <TableRender
                  id="InactivePolicesListTable"
                  schema={POLICIES_TABLE_ROWS}
                  rows={allInactivePolicies}
                />
              </div>
              
            )}         
          </Tab>
        </Tabs>
        </div>
      </div>

      <ModalReports  show={showMReports} handleClose={() => setShowMReports(false)} mData={{name: 'downloadPoliciesReportByDate', docName: 'Poliza', docExt: 'xlsx'}}/>
      <ModalPolicies show={show} handleClose={() => setShow(false)} mData={selectedElement}/>
      <AlertNotification
        show={alert?.show}
        title= {alert?.title}
        details= {alert?.details}
        variant={alert?.variant}
        onClose={resetAlert}
      />
    </>
  );
};
